module.exports = __webpack_public_path__ + "img/default_img169.9a684f81.jpg";